import script from "./Table_Fusion.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Fusion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__